module.exports = __webpack_public_path__ + "img/chevron-up.b109f70b.svg";